import React from 'react';

function ValideIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      viewBox="0 0 35 33"
      className={className}
    >
      <g
        stroke="#00AFEC"
        strokeWidth="2"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M31.9588754 15.3757792c.5148926 7.0826313-3.8496742 13.6091486-10.5921623 15.8388985-6.7424882 2.2297499-14.13788056-.4077331-17.94753063-6.4007837C-.3904676 18.8208435.36029622 11.0055042 5.24117592 5.84721411 10.12205563.688924 17.8843133-.49260557 24.0790346 2.97981548" />
        <path d="M11 12.7445923L16.5748138 20 34 1" />
      </g>
    </svg>
  );
}

export default ValideIcon;
